
import { mapActions, mapGetters } from 'vuex'
import props from './props.js'

export default {
  props,
  data() {
    return {
      selected: this.defaultValue,
      show: true,
    }
  },
  computed: {
    finalList() {
      if (this.disabled || this.disabledIfNoParentValue) return []

      const parentName = this.props.relation?.relatedFieldName
      const parentValue = this.props.relation?.watcher?.value
      const formattedOptions = this.options.reduce(
        (prev, { parentKey, key, content }) => {
          if (
            !parentName ||
            !parentValue ||
            !parentKey ||
            parentKey === parentValue ||
            (Array.isArray(parentValue) && parentValue.includes(parentKey))
          ) {
            return [...prev, { value: key, text: content }]
          }
          return prev
        },
        [],
      )

      return formattedOptions
    },
    ...mapGetters({
      countryNameFromStore: 'location/getCountryName',
    }),
  },
  watch: {
    selected: {
      handler(newValue) {
        if (this.changeable || this.changeable === '')
          this.$set(this.changeable, 'value', newValue)
      },
    },
    countryNameFromStore(newValue) {
      if (this.selected === '') this.selected = newValue
    },
  },
  mounted() {
    if (this.props?.relation) {
      this.$watch(
        'props.relation.watcher.value',
        (newValue) => {
          if (this.props.relation.stateBefore === 'hidden') {
            this.show = newValue?.length > 0 || newValue === true

            if (this.props.relation?.hideOnEmptyRelation === true) {
              this.show = this.finalList?.length > 0
              this.selected = ''
            }
          }
        },
        {
          immediate: true,
        },
      )
    }

    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client && this.defaultValue === '' && this.selected === '') {
      this.intersectionObserver = new IntersectionObserver(
        (entries, observer) => {
          if (entries[0].intersectionRatio <= 0) return
          this.initLocation()
          observer.disconnect()
        },
      )

      if (this.$el) this.intersectionObserver.observe(this.$el)
    }
  },
  beforeDestroy() {
    this.intersectionObserver.disconnect()
  },
  methods: {
    ...mapActions({
      initLocation: 'location/initLocation',
    }),
  },
}
